<template>
  <div>
    <div class="notice-content">
      <p class="title">打印指导</p>
      <div>
        <p>类型：箱码标签打印</p>
        <p>说明：箱码标签，更新打印方式（由print服务打印改为浏览器打印），不再需要启动print服务，直接通过浏览器打印即可。</p>
      </div>
      <div>
        <p class="blue blod">*属性信息</p>
        <p>打印机机型：Gprinter GP-1924D</p>
        <p>打印尺寸：80*50mm</p>
      </div>
      <div>
        <p class="blue blod">*打印设置（必设）</p>
        <p class="blue blod">1.浏览器</p>
        <p>推荐：chorme浏览器  <a class="blue" href="https://www.google.cn/chrome/thank-you.html" target="_blank">下载地址</a></p>
        <p>不支持：火狐浏览器等</p>
      </div>
      <div>
        <p class="blue blod">2.浏览器打印设置</p>
        <p>必设项：目标打印机、布局、纸张尺寸、边距。</p>
      </div>
      <div>
        <p>示例如图</p>
      </div>
    </div>
    <div style="text-align:center;">
      <img src="./../../assets/img/printNotice1.png" alt="" width="95%">
    </div>
    <div style="text-align:center;margin-top:20px;">
      <img src="./../../assets/img/printNotice.png" alt="" width="95%">
    </div>
    <div style="margin-bottom:30px;margin-right:40px;">
      <p style="text-align:right;font-weight:600;font-size:16px;">2019年9月5日</p>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style lang='scss' scoped>
.notice-content{
  padding: 20px;
  .title{
    font-size: 16px;
    font-weight: 600;
    margin-top: 20px;
  }
  div{
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .blod{
    font-weight: bold;
  }
  .blue{
    color: #236bdc;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/notice/printNotice.vue